export const reactSelectLight = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? '#4e8cff' : '#ced4da',
    height: '42px',
    color: '#000000',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#86b7fe'
    }
  }),

  menu: (base) => ({
    ...base,
    backgroundColor: '#ffffff',
    color: '#000000',
    borderRadius: 6,
    marginTop: 4,
    zIndex: 9999
  }),

  option: (base, { isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isSelected ? 'rgba(78, 140, 255, 0.15)' : isFocused ? '#f1f3f5' : '#ffffff',
    color: '#000000',
    cursor: 'pointer',
    fontSize: '0.85rem'
  }),

  singleValue: (base) => ({
    ...base,
    color: '#000000'
  }),

  placeholder: (base) => ({
    ...base,
    color: '#6c757d'
  }),

  valueContainer: (base) => ({
    ...base,
    height: '32px',
    padding: '0 6px'
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: '32px'
  })
};
